// based on rc-pagination 1.20.5
export { default } from './Pagination';
